import k from '../constants/k'
import type { GameObj, Vec2 } from 'kaplay'

k.loadSprite('star', 'sprites/ui/sparkle.png')
k.loadSprite('cursor', 'sprites/ui/cursor.png', {
  sliceX: 3,
  anims: {
    default: 2,
    drag: 0,
    pointer: 1
  }
})

const sparkle = (pos: Vec2) => {
  const parts = k.add([
    k.pos(pos.x, pos.y),
    k.particles(
      {
        max: 20,
        speed: [20, 30],
        angle: [0, 360],
        angularVelocity: [45, 90],
        lifeTime: [0.2, 1],
        colors: [k.rgb(245, 161, 161), k.rgb(248, 233, 229)],
        opacities: [0.1, 0.8, 0.0],
        scales: [0.2, 0.3, 0.2],
        texture: k.getSprite('star').data.tex,
        quads: [k.getSprite('star').data.frames[0]]
      },
      {
        lifetime: 1,
        rate: 0,
        direction: -90,
        spread: 400
      }
    )
  ])

  parts.emit(20)
}

export const mouse = () => {
  k.onClick(() => {
    sparkle(k.mousePos())
  })

  const cursor = k.add([
    k.sprite('cursor'),
    k.pos(100, 100),
    k.anchor('center'),
    k.z(10)
  ])
  cursor.play('default')
  cursor.onUpdate(() => {
    cursor.pos = k.mousePos()
  })

  return { cursor }
}

export const addHoverEffect = (target: GameObj, cursor: GameObj) => {
  target.onHover(() => {
    cursor.play('pointer')
    target.scale = k.vec2(1.1)
  })
  target.onHoverEnd(() => {
    cursor.play('default')
    target.scale = k.vec2(1)
  })
}
